export function decodeImage(images) {
  images.forEach(lowResImg => {
    if (lowResImg.complete) {
      upgrade(lowResImg);
    } else {
      lowResImg.addEventListener('load', () => upgrade(lowResImg), { once: true });
    }
  });
}

function getLargestSrc(srcset = '') {
  const last = srcset.split(',').pop()?.trim();
  return last ? last.split(/\s+/)[0] : '';
}

function upgrade(lowResImg) {
  lowResImg.setAttribute('data-status', 'loaded-low-res');
  
  const renderedWidth = lowResImg.clientWidth || lowResImg.naturalWidth;
  
  const highResImg = new Image();
  
  Array.from(lowResImg.attributes).forEach(attr => {
      switch (attr.name) {
      case 'alt':
      case 'width':
      case 'height':
      // case 'loading':
      case 'fetchpriority':
      // case 'decoding':
        highResImg.setAttribute(attr.name, attr.value);
        break;
      case 'data-srcset':
        highResImg.setAttribute('srcset', attr.value);
        break;
      case 'sizes':
        highResImg.setAttribute('sizes', `(max-width: ${renderedWidth}px) ${renderedWidth}px, 100vw`);
        break;
      default:
        // console.log('Orphan attribute', attr.name, attr.value);
    }
  });

  const largestSrc = getLargestSrc(lowResImg.getAttribute('data-srcset'));
  highResImg.src = largestSrc || lowResImg.currentSrc || lowResImg.src;

  highResImg.decode().then(() => {
    lowResImg.replaceWith(highResImg);
  });

  highResImg.addEventListener('load', () => {
    // console.log('highResImg loaded', highResImg);
  });
}